import React from 'react';
import { Suspense } from 'react';
import { useIntl } from 'react-intl';
import { useController } from 'rest-hooks';
import { LinearProgress, useTheme, Button } from '@mui/material';
import { EvaluatedResult } from './evaluatedResults';
import { TitledPaper } from '../components/titledPaper/titledPaper';
import { EvaluateScoreModel } from '../../model/entities/scoreModelEvaluation';
import { useScoreModel } from '../../model/context/scoreModelContext';
import { useApplication } from '../../model/context/applicationContext';

const RunButtonText = () => {
  const { invalidate } = useController();
  const { applicationNumber, applicationXml } = useApplication();
  const { scoreModel } = useScoreModel();
  const intl = useIntl();

  return (
    <Button
      variant="contained"
      color="primary"
      sx={{ marginTop: 1 }}
      onClick={() =>
        invalidate(
          EvaluateScoreModel,
          scoreModel.scoreModelId && applicationNumber && applicationXml
            ? {
                scoreModelId: scoreModel.scoreModelId,
                applicationNumber: applicationNumber,
                applicationXml: applicationXml
              }
            : null
        )
      }>
      {intl.formatMessage({ id: 'Test' })}
    </Button>
  );
};

export function TestRunner() {
  const intl = useIntl();
  const usePalette = useTheme().palette;

  return (
    <TitledPaper
      title={intl.formatMessage({
        id: 'EvaluatorTitle'
      })}
      elementTopRight={<RunButtonText />}
      color={usePalette.secondary.light}>
      <Suspense fallback={<LinearProgress />}>
        <EvaluatedResult />
      </Suspense>
    </TitledPaper>
  );
}
